/** Version of the data contracts described in docs/contracts/. */
export const CONTRACT_VERSION = '0.15.0';
/** Version of the calculation engine recorded in bake snapshots (D8). */
export const ENGINE_VERSION = '0.7.0';
//# sourceMappingURL=version.js.map